import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Typography } from 'antd';
import api from '../services/api';
import { palette, STATUS_COLORS, WARN_PILL } from '../theme';
import Pill from '../components/Pill';

const StatBlock: React.FC<{ label: string; value: number; bg: string; fg?: string }> = ({
  label, value, bg, fg = '#FFFFFF',
}) => (
  <div style={{
    background: bg, color: fg, borderRadius: 12, padding: '24px',
    minHeight: 120, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    <span style={{
      fontSize: 11.5, fontWeight: 700, letterSpacing: '0.08em',
      textTransform: 'uppercase', opacity: 0.85,
    }}>
      {label}
    </span>
    <span style={{
      fontFamily: "'Lora', Georgia, serif", fontSize: 40, fontWeight: 600,
      lineHeight: 1,
    }}>
      {value.toLocaleString('ru-RU')}
    </span>
  </div>
);

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState({ total: 0, russian: 0, no_inn: 0, manual_review: 0 });
  const [recent, setRecent] = useState<any[]>([]);

  useEffect(() => {
    api.get('/entities/stats/summary').then(r => setStats(r.data));
    api.get('/entities/', { params: { page: 1, page_size: 10 } })
      .then(r => setRecent(r.data.items || []));
  }, []);

  return (
    <div>
      <div className="eyebrow">Обзор</div>
      <Typography.Title level={3} className="page-title" style={{ marginTop: 0, marginBottom: 24 }}>
        Дашборд
      </Typography.Title>

      <Row gutter={16} style={{ marginBottom: 32 }}>
        <Col span={6}>
          <StatBlock label="Всего ЮЛ" value={stats.total} bg={palette.navy} />
        </Col>
        <Col span={6}>
          <StatBlock label="Российские ЮЛ" value={stats.russian} bg={palette.blue} />
        </Col>
        <Col span={6}>
          <StatBlock label="Без ИНН" value={stats.no_inn} bg={palette.orange} />
        </Col>
        <Col span={6}>
          <StatBlock label="Ручная проверка" value={stats.manual_review} bg={palette.sky} fg={palette.ink} />
        </Col>
      </Row>

      <div className="eyebrow">Активность</div>
      <Typography.Title level={5} className="page-title" style={{ marginTop: 0 }}>
        Последние добавленные
      </Typography.Title>
      <Table
        dataSource={recent}
        rowKey="id"
        size="small"
        columns={[
          { title: 'ID', dataIndex: 'id', width: 60 },
          { title: 'Название', dataIndex: 'name_en', ellipsis: true },
          { title: 'ИНН', dataIndex: 'inn', width: 120 },
          {
            title: 'РФ', dataIndex: 'is_russian', width: 50,
            render: (v: boolean) => v ? <Pill bg={WARN_PILL.bg} fg={WARN_PILL.fg}>РФ</Pill> : null,
          },
          {
            title: 'Статус', dataIndex: 'status', width: 140,
            render: (s: string) => {
              const info = STATUS_COLORS[s] || { bg: palette.border, fg: palette.muted, label: s };
              return <Pill bg={info.bg} fg={info.fg}>{info.label}</Pill>;
            },
          },
        ]}
        pagination={false}
      />
    </div>
  );
};

export default Dashboard;
